const Vue = window.Vue
const VueResource = window.VueResource
import carousel from './components/carousel.vue'
import './styles/lib.scss'

Vue.use(VueResource)

window.arkWidgetCarousel = {
  Init: function (inputData) {
    window.carousel = new Vue({
      el: inputData.el,
      data: function () {
        return {
          config: inputData.config
        }
      },
      created: function () {
        console.log('arkWidgetCarousel created')
      },
      render: h => h(carousel)
    })
  }
}
//
// window.arkWidgetCarousel.Init({el: '#carousel', config: { name: 'name', alwaysShowNav: true, locale: {play: 'play now12'}, backUrl: 'http://arenaservices-testing.as.arkadiumhosted.com/gamelist/api/gamelist/get/arenapromo/', arenaName: 'arena.ac4-0.arkadium.com' }})

export default carousel




// WEBPACK FOOTER //
// ./src/lib.js